// Global: panel açılışında (yol değişimi) ve oturum değişince (giriş / yenileme) cihaz kaydını
// sessizce tazeler — bkz. lib/deviceRegistration.js. Görünür bir şey çizmez.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { refreshDeviceRegistration } from "../lib/deviceRegistration";

export default function DeviceRegistrar() {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => { refreshDeviceRegistration(pathname); }, 1500);   // sayfa yüklensin
    return () => clearTimeout(t);
  }, [pathname]);
  useEffect(() => {
    const onAuth = (e) => {
      const type = e?.detail?.type;
      if (type === "login" || type === "refresh") refreshDeviceRegistration(window.location.pathname, { force: type === "login" });
    };
    window.addEventListener("auth-changed", onAuth);
    return () => window.removeEventListener("auth-changed", onAuth);
  }, []);
  return null;
}
